'use client';

import { c as _c } from "react/compiler-runtime";
import type { AppNavBarItem } from '@/components/footer/footer-nav-bar-menu-entries';
import { APP_NAV_BAR_ICONS, resolveAppNavBarEntries } from '@/components/footer/footer-nav-bar-menu-entries';
import { NavLink } from '@/components/footer/nav-link';
import type { Config } from '@/features/payload-cms/payload-types';
import { useKeyboardShrinksPage } from '@/hooks/use-keyboard-shrinks-page';
import { cn } from '@/utils/tailwindcss-override';
import { House } from 'lucide-react';
import { usePathname } from 'next/navigation';
import type React from 'react';
import { useMemo } from 'react';
export interface FooterAppNavBarProperties {
  locale: Config['locale'];
  items?: AppNavBarItem[] | undefined;
  /** on a desktop, a rail down the left edge instead of a bar along the bottom */
  railOnDesktop?: boolean;
}
export const FooterAppNavBar: React.FC<FooterAppNavBarProperties> = t0 => {
  const $ = _c(23);
  const {
    locale,
    items,
    railOnDesktop: t1
  } = t0;
  const railOnDesktop = t1 === undefined ? false : t1;
  const pathname = usePathname();
  const keyboardShrinksPage = useKeyboardShrinksPage();
  let t2;
  bb0: {
    if (items && items.length > 0) {
      t2 = items;
      break bb0;
    }
    let t3;
    if ($[0] !== locale) {
      t3 = resolveAppNavBarEntries(undefined, locale);
      $[0] = locale;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    t2 = t3;
  }
  const navItems = t2;
  let t3;
  let t4;
  if ($[2] !== navItems || $[3] !== pathname) {
    const pathnameWithoutLocale = pathname.replace(/^\/(de|en|fr)\/(.*)/, "/$2");
    t4 = navItems.reduce((accumulator, item) => {
      if (pathnameWithoutLocale.startsWith(item.href) && item.href.length > accumulator.length) {
        return item.href;
      }
      return accumulator;
    }, "");
    $[2] = navItems;
    $[3] = pathname;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  t3 = t4;
  const longestMatch = t3;
  const t5 = keyboardShrinksPage && (railOnDesktop ? "max-xl:typing:hidden" : "typing:hidden");
  const t6 = railOnDesktop && "xl:top-(--app-content-top) xl:left-0 xl:h-auto xl:w-(--app-content-left) xl:border-t-0 xl:border-r-2";
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = cn("fixed bottom-0 left-(--app-content-left) z-40 flex h-20 w-[calc(100dvw-var(--app-content-left))] border-t-2 border-gray-200 bg-[#f8fafc]", t5, t6);
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = railOnDesktop && "xl:flex-col xl:justify-start xl:gap-2 xl:px-0 xl:py-4";
  let t9;
  if ($[8] !== t8) {
    t9 = cn("flex w-full items-center justify-around px-4", t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== longestMatch || $[11] !== navItems || $[12] !== railOnDesktop) {
    let t11;
    if ($[14] !== longestMatch || $[15] !== railOnDesktop) {
      t11 = item_0 => {
        const IconComponent = APP_NAV_BAR_ICONS[item_0.iconName] ?? House;
        return <NavLink key={`${item_0.href}-${item_0.label}`} href={item_0.href} icon={IconComponent} label={item_0.label} isCurrent={longestMatch === item_0.href} color={item_0.color} className={cn(railOnDesktop && "xl:h-auto xl:w-full xl:flex-none")} />;
      };
      $[14] = longestMatch;
      $[15] = railOnDesktop;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    t10 = navItems.map(t11);
    $[10] = longestMatch;
    $[11] = navItems;
    $[12] = railOnDesktop;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <nav className={t9}>{t10}</nav>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[20] = t11;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};